import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { login, performLogout, refreshJwtToken } from '../actions/authActions';
import { AuthState, Role } from '../type/authType';

// #28: JWT/refresh більше не читаються з localStorage/JS-cookie. JWT — лише в пам'яті;
// refresh — httpOnly cookie. На старті сесія відновлюється через /Auth/Refresh (бутстрап у App).
export const initialState: AuthState = {
  jwtToken: null,
  refreshToken: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
    },
    loginSuccess: (
      state,
      action: PayloadAction<{
        jwtToken: string;
        refreshToken: string;
        roles: Role[];
        email: string;
      }>,
    ) => {
      state.jwtToken = action.payload.jwtToken;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      state.user = { email: action.payload.email, roles: action.payload.roles };
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.jwtToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      state.user = null;
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('reduxState');
    },
    loadUserSuccess: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.jwtToken = action.payload.jwtToken;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      state.user = { email: action.payload.email, roles: action.payload.roles };
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
    builder.addCase(refreshJwtToken.fulfilled, (state, action) => {
      state.jwtToken = action.payload.jwtToken;
    });
    builder.addCase(performLogout.fulfilled, (state) => {
      state.jwtToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.user = null;
    });
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  logout,
  loadUserSuccess,
} = authSlice.actions;

export default authSlice.reducer;
